/**
 * Constants for menu scope types and routes
 * @module utils/menuMaker/constants
 */

/**
 * Enum for menu scope types
 * @readonly
 */
// eslint-disable-next-line no-shadow
export enum MENU_SCOPE {
  /** Branch/store level scope */
  STORE = 'STORE',
  /** Organization level scope */
  ORGANIZATION = 'ORGANIZATION',
}

/**
 * Theme colors for different scopes
 * @readonly
 */
export const SCOPE_THEME_COLORS: Record<MENU_SCOPE, string> = {
  /** Store/branch background color */
  [MENU_SCOPE.STORE]: '#E8F5FF', // Light blue for store
  /** Organization background color */
  [MENU_SCOPE.ORGANIZATION]: '#F04E4A', // Red for organization
};

/**
 * Font colors for different scopes
 * @readonly
 */
export const SCOPE_FONT_COLORS: Record<MENU_SCOPE, string> = {
  /** Store/branch font color */
  [MENU_SCOPE.STORE]: '#000000', // Black for store
  /** Organization font color */
  [MENU_SCOPE.ORGANIZATION]: '#FFFFFF', // White for organization
};

/**
 * Key para persistir el scope en localStorage
 * @readonly
 */
export const LOCAL_STORAGE_MENU_SCOPE_KEY = 'parrot.selectedMenuScope';
export const LOCAL_STORAGE_ORG_ACCESS_KEY = 'parrot.orgAccess';

/**
 * Menu maker route definitions
 * @readonly
 */
export const MENU_ROUTES = {
  /** Root route for scope selection */
  ROOT: '/menu-scope',
  /** Menus management route */
  MENUS: '/menu-scope/menus',
  /** Menu resume route */
  RESUME: '/menu-scope/menus/resume',
  /** Categories management route */
  CATEGORIES: '/menu-scope/menus/categories',
  /** Products management route */
  PRODUCTS: '/menu-scope/menus/products',
  /** Modifier groups management route */
  MODIFIER_GROUPS: '/menu-scope/menus/modifier-groups',
  /** Menu publishing route */
  PUBLISH: '/menu-scope/menus/publish',
  /** Menu preview route with parameter */
  PREVIEW: '/menu-scope/menus/preview/:menuUuid',
};
